module.exports = "https://dev.stanwinstonschool.com/1-story-desktop.3561a032b36c05cb56da74bfe5243d31.jpg";